import { Commit, Dispatch } from 'vuex';
import { EditStore } from '@/main/store/@types/edit.d';
import { NdSklad } from '@/modules/sklad/ndSklad';
import { NdCenik } from '@/modules/sklad/ndCenik';

import { apiProvider } from '../../api';
import { edit, dropdownList, localState, props } from './state';
import { editActions, editMutations } from './types';

type State = EditStore<typeof edit, typeof dropdownList, typeof localState, {}, typeof props>;
type VuexProps = { commit: Commit, dispatch: Dispatch, state: State };

export const actions = <const>{
	async [editActions.OCENENI_ND]({ state, commit, dispatch }: VuexProps, input: Record<string, any>) {
		const zakazkandData = {
			NdNr: state.edit.NdNr,
			NezavislyDalsiVydej: state.edit.NezavislyDalsiVydej,
			PcPevna: state.edit.PcPevna,
			PcSpec: state.edit.PcSpec,
			SkladOzn: state.edit.SkladOzn,
			Sleva: state.edit.Sleva,
			Stav: state.edit.Stav,
			VydejMjPoc: state.edit.VydejMjPoc,
			VyrobekndOzn: state.edit.VyrobekndOzn,
			ZakazkaId: state.edit.ZakazkaId,
			NdskladId: state.localState.ndsklad.ZaznamId,
			ZakazkandId: state.edit.ZaznamId! < 0 ? null : state.edit.ZaznamId,
		};
		const oceneniInput = Object.assign(
			{
				JednotkovaCena: false,
				CelkovaCena: false,
				SmluvniCena: false,
				CenaEnum: 1,
				Rezim: 1,
				ZakazkandData: zakazkandData,
			},
			input,
		);
		if (oceneniInput.ZakazkandData !== null && oceneniInput.ZakazkandData.ZakazkaId !== null) {
			const { data: result } = await apiProvider.oceneniNd(oceneniInput);
			commit(editMutations.SET_OCENENI_ND, { oceneniInput, result });
			if (result.NdskladId) {
				const { data: ndsklad } = await NdSklad.apiProvider.entity(result.NdskladId);
				commit(editMutations.ND_SKLAD_ENTITY, { data: ndsklad });
			}
		}
	},
	async [editActions.CHECK_EXISTS_JFND]({ state, commit, dispatch }: VuexProps) {
		const existsJfndinput = {
			ZakazkaId: state.edit.ZakazkaId,
			SkladOzn: state.edit.SkladOzn,
			VyrobekndOzn: state.edit.VyrobekndOzn,
			NdNr: state.edit.NdNr,
		};
		// TODO: KIM - JFND zatial deaktivovana
		return (await apiProvider.checkExistsJfnd(existsJfndinput)).data && false;
	},
	async [editActions.GET_JFND_INPUT]({ state, commit, dispatch }: VuexProps) {
		return apiProvider.getForJfnd({
			ZakazkaId: state.edit.ZakazkaId,
			SkladOzn: state.edit.SkladOzn,
			VyrobekndOzn: state.edit.VyrobekndOzn,
			NdNr: state.edit.NdNr,
			PracovnikId: state.edit.PracovnikId,
		});
	},
	async [editActions.GET_IDENTICKY_ND]({ state, commit, dispatch }: VuexProps, ndsklad: Record<string, any>) {
		return apiProvider.getIdentickyNd({
			VyrobekndOzn: ndsklad.VyrobekndOzn,
			SkladOzn: ndsklad.SkladOzn,
			ZakazkaId: state.edit.ZakazkaId,
			Kdc: ndsklad.kdc,
			NcGd: ndsklad.NcGd !== 0 ? ndsklad.NcGd : ndsklad.Nc,
			NdNr: ndsklad.NdNr,
			Pc: ndsklad.Pc,
			Pnc: ndsklad.Pnc,
			PcPevna: state.edit.PcPevna,
			PcSpec: state.edit.PcSpec,
			SnId: state.edit.SnId,
			ZakazkandextodpisId: state.edit.ZakazkandextodpisId,
		});
	},
	async [editActions.VYDEJ_VRATKA]({ state, commit, dispatch }: VuexProps) {
		return apiProvider.vydejVratka({
			Dto: state.edit,
			Akce: state.localState.vydejVratkaResult.Akce,
			TestPcPolozkaQuestionResult: state.localState.vydejVratkaResult.TestPcPolozkaQuestionResult,
			UseSkladovyPrevodResult: state.localState.vydejVratkaResult.UseSkladovyPrevodResult,
		});
	},
	async [editActions.CHECK_ND_CENIK_ID]({ state, commit, dispatch }: VuexProps, ndcenikId: number) {
		if (ndcenikId > -1) {
			const ndcenik = await NdCenik.apiProvider.entity(ndcenikId);
			const input = {
				VyrobekndOzn: (ndcenik as Record<string, any>).VyrobekndOzn,
				NdNr: state.edit.NdNr,
				SkladOzn: state.edit.SkladOzn,
				EanCode: state.edit.EanCode,
				HledejPodretezecNdNr: false,
			};
			// CheckExistSkladovaKarta(input);
		}
	},
	async [editActions.ND_CENIK_KDC]({ state, commit, dispatch }: VuexProps, ndsklad: Record<string, any>) {
		return NdCenik.apiProvider.kdc({
			VyrobekndOzn: ndsklad.VyrobekndOzn,
			NdNr: ndsklad.NdNr,
			SkladOzn: ndsklad.SkladOzn,
		});
	},
};
